export default __webpack_public_path__ + "static/media/instagram.b4ff9be0.png";